<template>
  <base-section id="theme-features">
    <!-- <base-title>Theme Features </base-title> -->
    <base-section-heading title="Fright Network">
      As a shipper, our freight network helps you to connect with reliable
      carriers. This helps you to find a suitable option as per your need, ship
      reliably and responsibly.

      <br />
      <br />
      <br />
      For carriers, our helps you optimize your fleet usage and ship more with
      fewer trips, saving you more with each trip. With our connected network,
      you get more business, hence increasing earning for carriers.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <base-avatar-card
            title="Save Cost & Time"
            icon="mdi-currency-usd-off"
            align="left"
            horizontal
            color="primary"
            dark
          >
            As cargo volumes grow, our network becomes more efficient, lowering
            your total cost to ship.
          </base-avatar-card>
        </v-col>
        <v-col cols="12" md="6">
          <base-avatar-card
            title="Reliable and Flexible Capacity"
            icon="mdi-shield-link-variant-outline"
            align="left"
            horizontal
            color="primary"
            dark
          >
            Get the reliability and network planning capabilities of an
            asset-based carrier with the flexibility of a broker.
          </base-avatar-card>
        </v-col>
        <v-col cols="12" md="6">
          <base-avatar-card
            title="Improve Quality"
            icon="mdi-shield-check-outline"
            align="left"
            horizontal
            color="primary"
            dark
          >
            Move your freight with a carrier network 15% safer than the industry
            average.
          </base-avatar-card>
        </v-col>
        <v-col cols="12" md="6">
          <base-avatar-card
            title="Real Time Analytics & Insights"
            icon="mdi-chart-bar-stacked"
            align="left"
            horizontal
            color="primary"
            dark
          >
            Access real-time data that delivers insights to transform your
            business.
          </base-avatar-card>
        </v-col>
        <!-- <v-col v-for="(feature, i) in features" :key="i" cols="12" md="6">
          <base-avatar-card v-bind="feature" align="left" horizontal>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis
            illum veniam cum dolores ratione commodi beatae quas maxime,
            laboriosam excepturi solut!
          </base-avatar-card>
        </v-col> -->
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionThemeFeatures",

  data: () => ({
    features: [
      {
        title: "Pixel Perfect Design",
        icon: "mdi-fountain-pen-tip",
      },
      {
        title: "Retina Ready",
        icon: "mdi-cellphone",
      },
      {
        color: "primary",
        dark: true,
        title: "Easily Customizable",
        icon: "mdi-pencil-box-outline",
      },
      {
        title: "Image Parallax",
        icon: "mdi-image-size-select-actual",
      },
      {
        title: "Seo Optimized",
        icon: "mdi-ice-pop",
      },
      {
        title: "24/7 Support",
        icon: "mdi-help-circle-outline",
      },
    ],
  }),
};
</script>
